// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__3X4P9","icon":"Checkbox_icon__Jiwcu","label":"Checkbox_label__1Y4VH"};